/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'audio': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7 5.75a4.75 4.75 0 019.5 0v5a4.75 4.75 0 11-9.5 0v-5zm1.612-.85l3.972-2.292A3.255 3.255 0 008.612 4.9zm5.456-1.429L8.5 6.686v2.28l6.46-3.73a3.241 3.241 0 00-.893-1.765zM8.5 10.75v-.064L15 6.933v2.28l-5.906 3.41A3.235 3.235 0 018.5 10.75zm6.495.186l-4.707 2.717a3.25 3.25 0 004.707-2.717zM4.75 9a.75.75 0 01.75.75v1a6.25 6.25 0 1012.5 0v-1a.75.75 0 011.5 0v1a7.75 7.75 0 01-7 7.714V21h3.25a.75.75 0 010 1.5h-8a.75.75 0 010-1.5H11v-2.536a7.75 7.75 0 01-7-7.714v-1A.75.75 0 014.75 9z" _fill="#000"/>'
  }
})
